import { type VolumeBasedPriceV1 } from '@redteclab/api/clients/bully'

export const getDiscountForCurrentQuantity = (
  value: number,
  volumePricing: VolumeBasedPriceV1[],
  basePrice: number,
  selectedValue: number
): { discount?: number; quantity?: number } => {
  if (volumePricing) {
    for (const volumePrice of volumePricing) {
      if (
        value &&
        volumePrice.quantityThreshold &&
        volumePrice.quantityThreshold === value &&
        volumePrice.quantityThreshold !== selectedValue
      )
        return {
          discount: volumePrice.discountPercentage ?? 0,
          quantity: volumePrice.quantityThreshold,
        }
    }
  }

  return {
    discount: undefined,
    quantity: undefined,
  }
}
